import { ColumnsFactory } from "../../../../../../../shared/components/Grid/functions";

export const getColumnDefs = (translate) => {
  return [

    ColumnsFactory.TextColumn(translate('tipo'),"tipo",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('paga'),"paga",{pinned:'left'}),
    ColumnsFactory.TextColumn(translate('nombre'), "nombre",{pinned:'left'}),
    ColumnsFactory.NumericColumn(translate("año"), "anio",{pinned:'left'}),
    ColumnsFactory.NumericColumn(translate('mes'), "mes",{pinned:'left'}),
    ColumnsFactory.TextColumn("Cod.DN/SG","idDN"),
    ColumnsFactory.TextColumn("DN/SG","direccionNegocio"),
    ColumnsFactory.TextColumn(translate('filial'),"sociedad"),
    ColumnsFactory.TextColumn(translate('centro-costo-destino-abreviado'),"centroCostoDestino"),
    ColumnsFactory.DecimalColumn(translate('salario'), "salario"),
    ColumnsFactory.DecimalColumn(translate('finiquito'), "finiquito"),
    ColumnsFactory.DecimalColumn(translate('prima'), "prima"),
    ColumnsFactory.DecimalColumn(translate('indemnizacion'), "indemnizacion"),
    ColumnsFactory.DecimalColumn(translate('total-salario-bruto'), "bruto"),
    ColumnsFactory.DecimalColumn(translate('retencion-especial-acotado'), "ret_Hipot"),
    ColumnsFactory.DecimalColumn(translate('retencion-irpf-acotado'), "irpf"),
    ColumnsFactory.DecimalColumn(translate('retencion-ss-empleado'), "sS_Empleado"),
    ColumnsFactory.DecimalColumn(translate('total-salario-neto'), "salarioNeto"),
    ColumnsFactory.DecimalColumn(translate('ss-empresa'), "costo_SS"),
    ColumnsFactory.DecimalColumn(translate('total-costo-empresa'), "tot_Costo")
  ];
};
